import { injectQrCodeApi } from '@delmonicos/shared-sdk/libs/emsp/src/clients/redux/back-office/qr-code.service';
import { baseApi } from '@service/base.api';

export const qrCodeApi = injectQrCodeApi(baseApi);

export const { useGetConfigQuery, useGenerateIdentifierMutation } = qrCodeApi;
